import PortalPurchasedView from "@/views/portal/PortalPurchasedView";
import PortalNotificationsView from "@/views/portal/PortalNotificationsView";
import PortalTicketsView from "@/views/portal/PortalTicketsView";
import PortalTicketDetailView from "@/views/portal/PortalTicketDetailView";

const meta = { middleware: ["auth"], roles: ["client"] };

export default [
    {
        name: "portal.purchased",
        path: "purchased",
        component: PortalPurchasedView,
        meta,
    },
    {
        name: "portal.notifications",
        path: "my-notifications",
        component: PortalNotificationsView,
        meta,
    },
    {
        name: "portal.tickets",
        path: "support",
        component: PortalTicketsView,
        meta,
    },
    {
        name: "portal.tickets.show",
        path: "support/:id",
        component: PortalTicketDetailView,
        meta,
    },
];
